import { transformActions } from 'utils/';
import { GET_ORDER_HISTORY } from 'actions/types';

const initialState = {
  data: [],
  isLoading: false,
};

/**
 * @description Stores specific order history array details in redux state
 * @param {[]} state
 * @param {{}} action
 * @returns {[]}
 */
function history(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_ORDER_HISTORY];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');
  if (type === GET_ORDER_HISTORY) {
    return {
      data: [],
      isLoading: true,
    };
  }
  if (success.includes(type)) {
    return {
      data: payload,
      isLoading: false,
    };
  }
  if (failure.includes(type)) {
    return {
      data: [],
      isLoading: false,
    };
  }
  return state;
}

export default history;
